import { render, staticRenderFns } from "./ComparadorFolioItem.vue?vue&type=template&id=d235409e&scoped=true"
import script from "./ComparadorFolioItem.vue?vue&type=script&lang=js"
export * from "./ComparadorFolioItem.vue?vue&type=script&lang=js"
import style0 from "./ComparadorFolioItem.vue?vue&type=style&index=0&id=d235409e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d235409e",
  null
  
)

export default component.exports